import { Link } from "react-router-dom";
import youXformaLogo from "@/assets/youXforma_logo.svg";

export const Footer = () => {
  const footerLinks = {
    Product: [
      { label: "Features", href: "/#solution" },
      { label: "Pricing", href: "/#pricing" },
      { label: "How it Works", href: "/#how-it-works" },
      { label: "FAQ", href: "/#faq" }
    ],
    Solutions: [
      { label: "Figma to React", href: "/figma-to-react" },
      { label: "Figma to Vue", href: "/figma-to-vue" },
      { label: "Design Systems", href: "/#solution" },
      { label: "Developer Handoff", href: "/#solution" }
    ],
    Resources: [
      { label: "Blog", href: "/blog" },
      { label: "Documentation", href: "#" },
      { label: "Help Center", href: "#" },
      { label: "Community", href: "#" }
    ],
    Company: [
      { label: "About", href: "#" },
      { label: "Contact", href: "#" },
      { label: "Privacy Policy", href: "#" },
      { label: "Terms of Service", href: "#" }
    ]
  };

  return (
    <footer className="border-t border-border py-8 md:py-12 bg-gradient-to-b from-background to-muted/20">
      <div className="container-custom">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-12">
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="font-semibold mb-4 text-foreground">{category}</h3>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/') ? (
                      <Link 
                        to={link.href} 
                        className="text-muted-foreground hover:text-primary transition-colors text-sm"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a 
                        href={link.href} 
                        className="text-muted-foreground hover:text-primary transition-colors text-sm"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        
        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <Link to="/">
              <img 
                src={youXformaLogo} 
                alt="youXforma" 
                className="h-6 w-auto" 
                width="126" 
                height="24" 
              />
            </Link>
          </div>
          <div className="text-muted-foreground text-sm">
            © 2025 youXforma. All rights reserved.
          </div>
          <div className="text-muted-foreground text-sm">
            Made with 💜 for designers everywhere
          </div>
        </div>
      </div>
    </footer>
  );
};
